module.exports = __webpack_public_path__ + "static/media/PK.b38c9682.png";